import React, { useContext } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './FONASUBRKCredentialsScreen.css';

const FONASUBRKCredentialsScreen = () => {
  const { formProps, next } = useContext(FlowContext);

  const specialCharStr =
    'Cannot contain spaces or the following characters: " % & \' + ; = , ^ ` > < {} () ? #';

  return (
    <>
      <div className="container">
        <div className="title-wrapper">
          <h1 className="crendetials-screen-heading">
            Open a Brokerage Account
          </h1>
          <h2 className="crendetials-screen-subheading">
            Create a username. A temporary password will generate automatically
            and display on the application confirmation page.
          </h2>
        </div>
        <div className="user-name-input">
          <InputField
            type="text"
            title="Username"
            placeholder="User Name"
            {...formProps.username}
          />
          <div>
            <ol>
              <li>At least 6 characters long</li>
              <li>Do not use Social Security Number</li>
              <li>Must contain at least one letter</li>
              <li>Cannot contain more than 7 digits</li>
              <li>{specialCharStr}</li>
            </ol>
          </div>
        </div>
      </div>
      <div className="btn-container">
        <MFBeaconButton
          noButtonMargin
          variant="primary"
          size="normal"
          data-name="brkCredentailsContinueBtn"
          onClick={next()}
          label="Continue"
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FONASUBRKCredentialsScreen;
